import React from "react";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
// import MovieTable from "../MovieTable";
import { modal } from "../../../../util";
import ProgrammeTable from "../ProgrammeTable";
import apiHelper, { api } from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { toast } from "react-toastify";

function ImportButton(props) {
  const { disabled, onChangeHandler } = props;
  const ref = React.useRef();

  const reset = () => {
    console.log("here");
    ref.current.value = "";
  };

  return (
    <label htmlFor="import-data">
      <input
        id="import-data"
        type="file"
        hidden
        onChange={(event) => {
          onChangeHandler(event, reset);
        }}
        ref={ref}
      />
      <Button
        variant="contained"
        component="span"
        color="primary"
        disabled={disabled}
      >
        Import from .csv
      </Button>
    </label>
  );
}

export default function ProgrammeListingPage({ disabled, ...props }) {
  const { match } = props;
  const [type, setType] = React.useState("all");
  const [actionType, setActionType] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [tableRows, setTableRows] = React.useState([]);
  const [searchString, setSearchString] = React.useState("");
  const [globalFilter, setGlobalFilter] = React.useState("");

  // for pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalElements, setTotalElements] = React.useState(0);

  const { setLoading } = useLoading();

  const filterHandler = (targetType) => () => {
    setType(targetType);
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  const handleSelectChange = (e) => {
    setActionType(e.target.value);
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setPage(0);
  };

  const getProgrammes = React.useCallback(
    async (rowsNum) => {
      setLoading(true);
      try {
        const result = await apiHelper.hknt.hkntGetProgrammes(
          page,
          (page + 1) * rowsNum,
          rowsNum,
          null,
          globalFilter
        );
        setRows(result.data.content.filter((x) => x));
        setTotalElements(result.data.totalElements);
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    },
    [page, globalFilter]
  );

  const getAllProgrammes = React.useCallback(async () => {
    const result = await apiHelper.hknt.hkntGetAllProgrammes(globalFilter);
    setRows(result.data.content.filter((x) => x));
    setTotalElements(result.data.totalElements);
  }, [globalFilter]);

  const deleteProgramme = async (id) => {
    const decision = await modal.fire({
      title: "Delete Programme",
      text: "Are you sure to delete this programme?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        const result = await apiHelper.hknt.hkntDeleteProgrammeById(id);
        if (result.data.code === 0) {
          toast.dark("Programme deleted.");
          getProgrammes();
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleBulkAction = React.useCallback(async () => {
    switch (actionType) {
      case "DELETE":
        const ids = tableRows.map((o) => o.original.id);
        if (ids.length > 0) {
          const decision = await modal.fire({
            title: "Delete Programme",
            text: `Are you sure to delete ${ids.length} programme(s)?`,
            showCancelButton: true,
            confirmButtonText: `Delete`,
          });
          if (decision.isConfirmed) {
            try {
              const promises = ids.map((id) =>
                apiHelper.hknt.hkntDeleteProgrammeById(id)
              );
              const results = await Promise.all(promises);
              console.log(results);
              toast.dark(`${ids.length} programme(s) deleted.`);
              getProgrammes();
            } catch (err) {
              console.log(err);
            }
          }
        }
        break;
      default:
        break;
    }
  }, [tableRows, actionType, getProgrammes]);

  const handleFileUpload = async (event, reset) => {
    event.preventDefault();
    const fd = new FormData();
    fd.append("file", event.target.files[0]);
    try {
      const result = await api.post("/hknt/admin/programme/import", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (0 === result?.data?.code) {
        toast.dark("Successfully imported.");
        getProgrammes();
      }
    } catch (err) {
      console.log(err);
    } finally {
      reset();
    }
  };

  React.useEffect(() => {
    if (rowsPerPage > 0) {
      getProgrammes(rowsPerPage);
    } else {
      getAllProgrammes();
    }
  }, [getProgrammes, rowsPerPage]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Programmes & Periods
      </Typography>
      {/* <StatusFilter>
        <li>
          <button
            className={type === "all" ? "active" : ""}
            type="button"
            onClick={filterHandler("all")}
          >
            <Typography variant="p">All</Typography>
          </button>
        </li>
        <li>
          <button
            className={type === "published" ? "active" : ""}
            type="button"
            onClick={filterHandler("published")}
          >
            <Typography variant="p">Published</Typography>
          </button>
        </li>
        <li>
          <button
            className={type === "draft" ? "active" : ""}
            type="button"
            onClick={filterHandler("draft")}
          >
            <Typography variant="p">Draft</Typography>
          </button>
        </li>
      </StatusFilter> */}
      <Grid container justify="space-between">
        {/* <Grid container item xs={6} md={6}> */}
        <Grid container item xs={3} md={3}>
          {/* <Grid item xs={6}> */}
          <Box width="100%" component="span" display="flex">
            <Box width="100%">
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  Bulk Actions
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={actionType}
                  onChange={handleSelectChange}
                  label="Bulk Actions"
                  disabled={disabled}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"DELETE"}>Delete</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex">
              <Button
                variant="outlined"
                color="primary"
                onClick={handleBulkAction}
                disabled={disabled}
              >
                Apply
              </Button>
            </Box>
          </Box>
          {/* </Grid> */}

          {/* Uncomment these in case the date filtering function is needed later */}

          {/* <Grid item xs={6}>
            <Box width="100%" component="span" display="flex">
              <Box width="100%">
                <FormControl fullWidth margin="dense" variant="outlined">
                  <InputLabel id="demo-simple-select-outlined-label">
                    All dates
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={age}
                    onChange={handleChange}
                    label="All dates"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"delete"}>Delete</MenuItem>
                    <MenuItem value={"delete"}>Delete</MenuItem>
                    <MenuItem value={"delete"}>Delete</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex">
                <Button variant="outlined" color="primary">
                  Filter
                </Button>
              </Box>
            </Box>
          </Grid> */}
        </Grid>
        {/* <Grid container item xs={12} md={6}> */}
        <Grid container item xs={9} md={6}>
          <Box
            width="100%"
            component="span"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box display="flex">
              <ImportButton
                onChangeHandler={handleFileUpload}
                disabled={disabled}
              />
            </Box>
            <Box display="flex">
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to={`${match.url}/create`}
                disabled={disabled}
              >
                Add New Programme
              </Button>
            </Box>
            <Box display="flex">
              <TextField
                id="outlined-error"
                label="Search Movie"
                variant="outlined"
                margin="dense"
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
              />
            </Box>
            <Box display="flex">
              <Button
                onClick={() => handleSearch(searchString)}
                variant="outlined"
                color="primary"
              >
                Search
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <ProgrammeTable
        globalFilter={globalFilter}
        data={rows}
        passTableRows={setTableRows}
        deleteProgramme={deleteProgramme}
        totalElements={totalElements}
        page={page}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disabled={disabled}
      />
    </Box>
  );
}
